import PendingApprovalContent from "../components/PendingApprovalContent";
import useRequestApproval from "../hook/useRequestApproval";

const PendingApproval = () => {
  const RequestApprovalProps = useRequestApproval();
  return <PendingApprovalContent {...RequestApprovalProps} />;
};

export default PendingApproval;